// extracted by mini-css-extract-plugin
export default {"PostCreate":"qt_a bic_qt bic_a bic_w bic_ea"};